<template>
  <div class="user-block" v-click-outside="hideSettings">
    <div class="user-block__content" @click="toggleSettings">
      <div class="user-block__avatar">
        <svg
          width="29"
          height="29"
          viewBox="0 0 29 29"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="29" height="29" rx="7" fill="#64748B" />
          <path
            d="M14.5784 22.5731C10.0668 22.5731 6.39648 18.8802 6.39648 14.3407C6.39648 9.80083 10.0668 6.10742 14.5784 6.10742C19.0913 6.10742 22.7627 9.80055 22.7627 14.3407C22.7627 18.8802 19.0913 22.5731 14.5784 22.5731ZM14.5784 7.48819C10.8281 7.48819 7.77698 10.5621 7.77698 14.3407C7.77698 18.1187 10.8278 21.1923 14.5784 21.1923C18.33 21.1923 21.3822 18.1187 21.3822 14.3407C21.3822 10.5624 18.33 7.48819 14.5784 7.48819Z"
            fill="white"
          />
          <path
            d="M24.2584 24.8034C24.6397 24.8034 24.9487 24.4943 24.9487 24.113V24.1715C24.9487 21.6778 23.5677 19.7883 20.9543 18.707C20.6021 18.5611 20.1986 18.7287 20.0527 19.0806C19.9071 19.4328 20.0744 19.8366 20.4266 19.9822C22.5405 20.8572 23.5683 22.2273 23.5683 24.1713V24.113C23.568 24.4943 23.877 24.8034 24.2584 24.8034Z"
            fill="white"
          />
          <path
            d="M24.2588 24.8034C24.6402 24.8034 24.9492 24.4943 24.9492 24.113V24.1715C24.9492 21.6778 23.5682 19.7883 20.9547 18.707C20.6025 18.5611 20.1989 18.7287 20.0531 19.0806C19.9075 19.4328 20.0748 19.8366 20.427 19.9822C22.541 20.8572 23.5687 22.2273 23.5687 24.1713V24.113C23.5684 24.4943 23.8775 24.8034 24.2588 24.8034Z"
            fill="white"
          />
          <path
            d="M4.69038 24.8034C4.30907 24.8034 4 24.4943 4 24.113V24.1715C4 21.6778 5.38104 19.7883 7.99451 18.707C8.3467 18.5611 8.75028 18.7287 8.89615 19.0806C9.04176 19.4328 8.87445 19.8366 8.52225 19.9822C6.40824 20.8572 5.38049 22.2273 5.38049 24.1713V24.113C5.38077 24.4943 5.0717 24.8034 4.69038 24.8034Z"
            fill="white"
          />
          <path
            d="M12.458 14.1776H11.5256C11.144 14.1776 10.835 13.8686 10.835 13.487C10.835 13.1059 11.144 12.7969 11.5256 12.7969H12.458C12.8394 12.7969 13.1484 13.1059 13.1484 13.487C13.1484 13.8686 12.8394 14.1776 12.458 14.1776Z"
            fill="white"
          />
          <path
            d="M17.7515 14.1776H16.8188C16.4375 14.1776 16.1284 13.8686 16.1284 13.487C16.1284 13.1059 16.4375 12.7969 16.8188 12.7969H17.7515C18.1328 12.7969 18.4419 13.1059 18.4419 13.487C18.4419 13.8686 18.1328 14.1776 17.7515 14.1776Z"
            fill="white"
          />
          <path
            d="M16.2858 16.1191C15.6905 17.3096 14.5001 17.3096 14.5001 17.3096C14.5001 17.3096 13.3096 17.3096 12.7144 16.1191"
            stroke="white"
            stroke-linecap="round"
          />
        </svg>
      </div>
      <div class="user-block__info">
        <div class="user-block__full-name">
          {{ userData.FirstName }} {{ userData.LastName }}
        </div>
        <div class="user-block__caret-icon">
          <svg
            width="8"
            height="5"
            viewBox="0 0 8 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.26688 4.52433L7.78955 1.0016C7.87109 0.920118 7.91602 0.811354 7.91602 0.695382C7.91602 0.57941 7.87109 0.470646 7.78955 0.38917L7.53019 0.129745C7.36119 -0.0390649 7.08651 -0.0390649 6.91777 0.129745L3.95964 3.08787L0.998234 0.126462C0.916693 0.0449859 0.807993 0 0.692085 0C0.576049 0 0.467349 0.0449859 0.385744 0.126462L0.126448 0.385887C0.0449071 0.467428 -1.43051e-05 0.576128 -1.43051e-05 0.6921C-1.43051e-05 0.808072 0.0449071 0.916836 0.126448 0.998313L3.65233 4.52433C3.73413 4.606 3.84335 4.65086 3.95945 4.6506C4.076 4.65086 4.18515 4.606 4.26688 4.52433Z"
              fill="#666D79"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="user-block__settings" v-show="isSettingsOpened">
      <router-link to="/cabinet/profile" class="user-block__link">
        {{ $t('header.profile_settings') }}
      </router-link>
      <locale-switcher class="user-block__locale-switcher"></locale-switcher>
      <logout-button @click="logoutUser"></logout-button>
    </div>
  </div>
</template>

<script>
import LocaleSwitcher from '@vue-app/components/header/parts/LocaleSwitcher.vue'
import LogoutButton from '@vue-app/components/base/button/LogoutButton.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'HeaderUserBlock',
  components: { LogoutButton, LocaleSwitcher },
  data() {
    return {
      isSettingsOpened: false,
      user: {},
    }
  },
  computed: {
    ...mapGetters(['userData']),
  },
  methods: {
    toggleSettings() {
      this.isSettingsOpened = !this.isSettingsOpened
    },
    hideSettings() {
      this.isSettingsOpened = false
    },
    logoutUser() {
      location.href = '/api/user/logout'
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@css-app/variables';
@import '@css-app/mixins';
.user-block {
  position: relative;
  padding-right: 15px;
  &__content {
    display: flex;
    align-items: center;

    transition: opacity 0.2s linear;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  }

  &__avatar {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 29px;
    height: 29px;
    margin-right: 12px;

    svg,
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__full-name {
    font-weight: 600;
    font-size: pxToRem(12);
    line-height: pxToRem(20);
    color: $text2;
    margin-bottom: 1px;
  }

  &__position {
    font-weight: 500;
    font-size: pxToRem(10);
    line-height: pxToRem(12);
    color: #666d79;
    opacity: 0.7;
  }

  &__caret-icon {
    position: absolute;
    right: 0;
    top: 10px;

    width: 8px;
    height: 8px;

    display: flex;
    align-items: center;
    justify-content: center;

    svg,
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }

  &__settings {
    position: absolute;
    top: calc(100% + 10px);
    right: 0;
    min-width: 200px;
    background: #ffffff;
    box-shadow: 0px -5px 60px rgba(120, 140, 184, 0.1);
    border-radius: 22px;
    padding: 16px 25px 20px;
    z-index: 9888;
  }

  &__link {
    @include nav-link-style;
    text-decoration: none;
    transition: opacity 0.2s linear;
    white-space: nowrap;

    &:hover {
      opacity: 0.8;
    }
  }

  &__locale-switcher {
    margin-top: 20px;
    margin-bottom: 17px;
    padding-top: 20px;
    padding-bottom: 18px;
    border-top: 1px solid $stroke;
    border-bottom: 1px solid $stroke;
  }
}
</style>
